import script from "./pieChart.vue?vue&type=script&setup=true&lang=js"
export * from "./pieChart.vue?vue&type=script&setup=true&lang=js"

import "./pieChart.vue?vue&type=style&index=0&id=3d726a67&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src2302593107/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3d726a67"]])

export default __exports__